import api from '@state/api';
const workerEndPoint = `${process.env.WORKER_API}/workerapi/v1`;
export const getAlarmHistoryRange = async (deviceid, start, end) => {
    const { data } = await api.get(`${workerEndPoint}/alarmlog/${deviceid}/range?start=${start}&end=${end}`);
    return data;
};
